(ns ballot-scout-v2-frontend.dashboard.subs
  (:require
   [ballot-scout-v2-frontend.dashboard.common :refer [dis-key]]
   [ballot-scout-v2-frontend.util :as util]
   [re-frame.core :as rf]))

(defn- calc-total-ballots
  "Omits some of the stat data from the total ballot count, since they are redundant"
  [stats]
  (let [ignored-stats #{:voter-bound/assumed-delivered
                        :office-bound/assumed-delivered
                        :usps/returned}
        new-stats (filter (fn [s]
                            (not (contains? ignored-stats (:name s)))) stats)]
    (apply + (map :value new-stats))))

(defn count-assumed-as-delivered
  "Updates the status counts for delivered and out-for-delivery ballots to reflect 
   that the number of assumed-delivered ballots were actually delivered"
  [stats]
  (let [vb-assumed (:value (first (filter (fn [d] (= (:name d) :voter-bound/assumed-delivered)) stats)))
        ob-assumed (:value (first (filter (fn [d] (= (:name d) :office-bound/assumed-delivered)) stats)))
        updated-map (-> (into (sorted-map) (map (fn [e] {(:name e) (:value e)}) stats))
                        (update :office-bound/delivered + ob-assumed)
                        (update :office-bound/out-for-delivery - ob-assumed)
                        (update :voter-bound/delivered + vb-assumed)
                        (update :voter-bound/out-for-delivery - vb-assumed)
                        (dissoc :voter-bound/assumed-delivered)
                        (dissoc :office-bound/assumed-delivered))]
    (filter #(> (:value %) 0)
            (map (fn [[k v]] {:name k :value v}) updated-map))))

(defn delivered-count
  "Returns a count of all ballot status that are logically beyond out-for-delivery"
  [stats]
  (let [not-delivered-statuses #{:disposition/created
                                 :disposition/mailed
                                 :voter-bound/mailed
                                 :voter-bound/in-transit
                                 :voter-bound/out-for-delivery
                                 :voter-bound/returned
                                 :usps/returned}]
    (->> stats
         (remove #(not-delivered-statuses (:name %)))
         (map :value)
         (apply +))))

(defn- return-to-sender-count [stats]
  (+ (:value (first (filter #(= (:name %) :voter-bound/returned) stats)))
     (:value (first (filter #(= (:name %) :office-bound/returned) stats)))))

(defn- assoc-usps-returned [stats]
  (conj stats {:value (return-to-sender-count stats)
               :name :usps/returned}))

(rf/reg-sub
 ::ballots-by-status
 (fn [db]
   (let [ballots-by-status (:ballots-by-status db)]
     (if (and (sequential? ballots-by-status) (> (count ballots-by-status) 0))
       (assoc-usps-returned ballots-by-status)
       ballots-by-status))))

(rf/reg-sub
 ::ballot-status-counts
 :<- [::ballots-by-status]
 (fn [ballots-by-status]
   (when (sequential? ballots-by-status)
     (some->> ballots-by-status
              (map (fn [{:keys [name value]}] [name value]))
              (into {})))))

(rf/reg-sub
 ::total-ballots
 :<- [::ballots-by-status]
 (fn [ballots-by-status]
   (when (sequential? ballots-by-status) (calc-total-ballots ballots-by-status))))

(rf/reg-sub
 ::delivered-pct
 :<- [::ballots-by-status]
 :<- [::total-ballots]
 (fn [[ballots-by-status total-ballots]]
   (when (sequential? ballots-by-status)
     (some-> ballots-by-status
             count-assumed-as-delivered
             delivered-count
             (/ total-ballots)
             ((partial * 100.0))
             util/round))))

(rf/reg-sub
 ::rts-count
 :<- [::ballots-by-status]
 (fn [ballots-by-status]
   (when (sequential? ballots-by-status) (return-to-sender-count ballots-by-status))))

(rf/reg-sub
 ::ballots-by-location
 (fn [db]
   (:ballots-by-location db)))

(rf/reg-sub
 ::maps-lib-loaded
 (fn [db]
   (:maps-lib-loaded db)))

(rf/reg-sub
 ::days-in-service-stats
 (fn [db]
   (:days-in-service-stats db)))

(rf/reg-sub
 ::dis-export
 (fn [db]
   (get-in db [dis-key :export])))

(rf/reg-sub
 ::noty-stats
 (fn [db]
   (:noty-stats db)))
